module.exports = __webpack_public_path__ + "img/Ruby.8cf98d13.png";